module.exports = __webpack_public_path__ + "static/img/liza.685fb13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liza.jpg
// module id = FNzu
// module chunks = 0